<template>
  <div class="top_title">
    <div class="top_name title_size flex">
      <div class="flex_1" v-html="name"></div>
      <div
        v-if="showButton"
        class="button_icon"
        :style="buttonStyle"
        @click="buttonClick(false)"
      >
        {{ buttonName }}
      </div>
      <div v-if="showSwitch" class="d-flex align-items-center">
        <el-switch  v-model="sValue" @change="sValueChange" style="--el-switch-on-color: #22BBE8; --el-switch-off-color: #D5D7D9"/>
        <span class="ms-1">{{ sValue?$t("smart_OM_model.open"):$t("smart_OM_model.closed") }}</span>
      </div>
    </div>
    <!-- 生产状态 -->
    <div class="output_status">
      <img :src="imageLists[`divider${lineType}`]" alt="" />
    </div>
  </div>
</template>

<script>
import { alertComfirm } from "@/helpers/swal";
import { ElMessageBox } from 'element-plus';
import i18n from "@/i18n";
export default {
  name: "Top",
  data() {
    return {
      imageLists: {
        divider: require("@/assets/icon-font/icon-divider.svg"),
        divider1: require("@/assets/icon-font/icon-divider1.svg"),
        divider2: require("@/assets/icon-font/icon-divider2.svg"),
      }
    };
  },
  emit:["switchChange"],
  props: {
    name: {
      type: String,
      default: ""
    },
    showButton: {
      type: Boolean,
      default: false
    },
    buttonName: {
      type: String,
      default: ""
    },
    buttonStyle: {
      type: Object,
      default: null
    },
    buttonClick: {
      type: Function,
      default: () => {}
    },
    lineType: {
      type: String,
      default: ""
    },
    showSwitch:{
      type: Boolean,
      default: false
    },
    switchValue:{
      type: Boolean,
      default: false
    }
  },
  computed:{
    sValue(){
      return this.switchValue;
    }
  },
  methods: {
    sValueChange(val){
      this.$nextTick(()=>{
        let dom = document.getElementById("app") //防止全屏层级被遮挡
        let msg = val?i18n.global.t("smart_OM_model.activate_smart_OM_modle"):i18n.global.t("smart_OM_model.close_smart_OM_modle")
        ElMessageBox.confirm(msg, '', {
          "show-close":false,
          cancelButtonText: i18n.global.t("base.cancel"),
          confirmButtonText:i18n.global.t("base.confirm"),
          center: true,
          customClass:'smartMessageBox',
          confirmButtonClass:'confirm-btn',
          cancelButtonClass:'cancel-btn',
          appendTo:dom,
        }).then(() => {
          this.$emit("switchChange",val)
        })
      })

    },
  },
  components: {},
};
</script>
<style  lang="scss">
//switch切换的提示box样式
.confirm-btn{
  margin-top: 20px;
  background-color: #40C95A !important;
  border: none  !important;
}
.cancel-btn{
  margin-top: 20px;
}
.cancel-btn:hover {
    background-color: #fff !important;
    border-color: #dcdfe6 !important;
    color:#333333 !important;
}
.smartMessageBox{
  height: 140px;
  background: #213247 !important;
  .el-message-box__container{
    color: #fff !important;
  }
}
</style>
<style scoped lang="scss">
@import url("../../assets/scss/common.scss");
.top_title {
  width: 100%;
  line-height: 20px;
}
.top_name {
  display: flex;
  align-items: center;
}
.button_icon {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 4px 5px;
  font-size: 12px;
  &:hover {
    cursor: pointer;
  }
}
.output_status {
  width: 100%;
  line-height: 10px;
  background-size: cover;
  background-repeat: no-repeat;
}
:deep(.swal2-container) {
  z-index: 1000001 !important;
}
</style>
